<template>
    <div class="hall-card" :class="[`hall-card-${index}`, (!hall.enabled || !hall.accessable) ? 'disabled' : '']"
        @click="$emit('select')">

        <!-- Title image -->
        <img class="hall-title" :src="titleImages[index]" :alt="hall.title" />

        <!-- Betting info -->
        <transition name="fade-update" mode="out-in">
            <div class="betting-info" :key="currentRate">
                <div class="info-entry">
                    <span class="info-label">{{ $t('niuniu.access') }}</span>
                    <span class="info-value">{{ currentConfig?.minimumEntry }}</span>
                </div>
                <div class="info-betting">
                    <span class="info-label">{{ $t('niuniu.limit') }}</span>
                    <span class="info-value">{{ currentConfig?.minBet }}-{{ currentConfig?.maxBet }}</span>
                </div>
            </div>
        </transition>

        <div class="hall-message">
            <span class="message-lable">{{ hallLabel }}</span>
            <img class="message-img" :src="arrowImages[index]" alt="">
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
// 静态导入所有图片资源
import titleL from '../img/hall-cover/room0_CN.webp'
import titleLEn from '../img/hall-cover/titleroom0_EN.webp'
import titleN from '../img/hall-cover/room1_CN.webp'
import titleNEn from '../img/hall-cover/room1_EN.webp'
import titleR from '../img/hall-cover/room2_CN.webp'
import titleREn from '../img/hall-cover/room2_EN.webp'

import arrow0 from '../img/hall-cover/arrow-0.png'
import arrow1 from '../img/hall-cover/arrow-1.png'
import arrow2 from '../img/hall-cover/arrow-2.png'


import type { GameHall, HallConfig } from '../ts/gameTps'
const props = defineProps<{
    hall: GameHall
    index: number
    currentRate?: string
}>()

const emit = defineEmits<{
    (e: 'select'): void
}>()

// 获取当前语言
const { locale, t } = useI18n();

// 图片资源数组
const titleImages = [locale.value == 'cn' ? titleL : titleLEn, locale.value == 'cn' ? titleN : titleNEn, locale.value == 'cn' ? titleR : titleREn]
const arrowImages = [arrow0, arrow1, arrow2]

// 房间标签翻译
const hallLabel = computed(() => {
    const labelKeys = ['hallLabel01', 'hallLabel02', 'hallLabel03']
    return t(`niuniu.${labelKeys[props.index]}`)
})

// 当前倍率
const currentRate = computed(() => props.currentRate || 'x3')

// 获取当前倍率对应的配置
const currentConfig = computed<HallConfig>(() => {
    const rate = currentRate.value
    const config = props.hall[rate as keyof GameHall] as HallConfig
    return config
})
</script>

<style scoped>
.hall-card {
    position: relative;
    width: 17.563rem;
    height: 9rem; 
    border-radius: 5.4375rem;
    overflow: hidden;
    cursor: pointer;
    background-size: contain;  
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    transition: all 0.3s ease;
    background-position: center;
}

.hall-card.disabled {
    opacity: 1 !important;
    filter: brightness(0.5);
}

/* 渐变边框伪元素 */
.hall-card::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 87px;
    padding: 2px;
    background: linear-gradient(177.91deg, #FFB32F 1.76%, #FFEC41 115.06%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    z-index: 1;
}

.hall-card:hover {
    transform: translateY(-0.125rem);
    box-shadow: 0 0 1.25rem rgba(255, 179, 47, 0.5);
}

.hall-card:hover::before {
    opacity: 1;
}

/* 卡片定位 */
.hall-card-0 {
    background-image: url(../img/hall-cover/bg-0.webp);
}

.hall-card-1 {
    background-image: url(../img/hall-cover/bg-1.webp);
}

.hall-card-2 {
    background-image: url(../img/hall-cover/bg-2.webp);
}


/* 标题图片 */
.hall-title {
    width: 5.188rem;
    height: 2.25rem;
    margin: 0 auto;
    margin-top: 0.313rem;
}

/* 投注信息 */
.betting-info {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
}


.info-entry,
.info-betting {
    display: flex;
    align-items: center;
    gap: 0.125rem;
    border-radius: 0.25rem;
    padding: 0.188rem 0.25rem;
    width: fit-content;
    transition: all 0.2s ease;
    background: #111923B2;
    border: 0.031rem solid #006970;
}

.hall-card-2 .info-entry {
    border: 0.031rem solid;
    border-image-source: linear-gradient(270deg, #8120EC -8.72%, #F37346 107.95%);
}

.hall-card-2 .info-betting {
    border: 0.031rem solid;
    border-image-source: linear-gradient(270deg, #8120EC -8.72%, #F37346 107.95%);
}

.info-label {
    font-size: 0.5rem;
    color: #A7B5CA;

    font-weight: 400;
    line-height: 0.75rem;
}

.info-value {
    font-size: 0.75rem;
    color: #FFFFFFB2;
    font-weight: 500;
    line-height: 0.75rem;
    transition: all 0.2s ease;
}

.hall-message {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.313rem;
}

.message-lable {
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 0.75rem;
    letter-spacing: 0.031rem;
}

.message-img {
    width: 1.375rem;
    height: auto;
}
.hall-card-0 .message-lable{
    color: #00B768;
}
.hall-card-1 .message-lable{
    color: #3FB6FF;
}
.hall-card-2 .message-lable{
    color: #FFDD18;
}

/* 限红信息切换动画 */
.fade-update-enter-active,
.fade-update-leave-active {
    transition: all 0.2s ease;
}

.fade-update-enter-from {
    opacity: 0;
    transform: translateY(0.188rem);
}

.fade-update-leave-to {
    opacity: 0;
    transform: translateY(-0.188rem);
}

/* 数值变化高亮提示 */
.fade-update-enter-active .info-value {
    animation: value-highlight 0.4s ease-out;
}

@keyframes value-highlight {
    0% {
        color: #1B2636;
    }

    50% {
        color: #3C1AEA;
        transform: scale(1.05);
    }

    100% {
        color: #1B2636;
    }
}
</style>